import { computed, nextTick, ref, Ref, watch, WatchStopHandle } from 'vue';
import { IMultiSelect } from '@studyportals/multiselect/dist/src/interfaces/multiselect.interface';
import { IOption } from '@studyportals/multiselect/dist/src/interfaces/options.interface';
import { ValidationProperties } from '@/models/validation.interface';
import { LoadingStatuses, LoadingTypes } from '@/models/loading.interface';
import validationPresenter from '@/presenters/validation-presenter';
import store from '@/store';

export default class AccountManagerCode {
	public accountManagerDropdown: Ref<IMultiSelect | null> = ref(null);
	private unwatchPrimary: WatchStopHandle | null = null;
	private unwatchAccountManager: WatchStopHandle | null = null;

	public get loadingType(): LoadingTypes {
		return LoadingTypes.ACCOUNT_MANAGER;
	}

	public accountManager = computed((): number | null => {
		return store.getters.accountManager();
	});

	public options = computed((): IOption[] => {
		return store.getters.allAccountManagers();
	});

	public isLoading = computed((): boolean => {
		return this.isAccountManagerDataLoading.value || this.isPrimaryDataLoading.value;
	});

	private isAccountManagerDataLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusAccountManagers();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	private isPrimaryDataLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPrimaryData();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public isFieldValidatedAndMissing = computed((): boolean => {
		return validationPresenter.isPropertyMissing(ValidationProperties.ACCOUNT_MANAGER);
	});

	private isAccountManagerSet = computed((): boolean => {
		return this.accountManager.value !== null;
	});

	public mounted(): void {
		this.unwatchAccountManager = watch(this.isAccountManagerDataLoading, this.prefillAccountManager.bind(this));
		this.unwatchPrimary = watch(this.isPrimaryDataLoading, this.prefillAccountManager.bind(this));
		void this.prefillAccountManager();
	}

	public unmounted(): void {
		if (this.unwatchPrimary) {
			this.unwatchPrimary();
		}
		if (this.unwatchAccountManager) {
			this.unwatchAccountManager();
		}
	}

	public setAccountManager(option: IOption): void {
		store.mutations.setAccountManager(option.value as number);

		if (!this.isFieldValidatedAndMissing.value) {
			return;
		}

		validationPresenter.validateMandatoryFields();
	}

	private async prefillAccountManager(): Promise<void> {
		if (this.isLoading.value) {
			return;
		}

		await nextTick();

		if (!this.accountManagerDropdown.value || !this.isAccountManagerSet.value) {
			return;
		}

		const selectedOption = this.options.value.find((option) => option.value === this.accountManager.value);
		if (!selectedOption) {
			return;
		}

		this.accountManagerDropdown.value.selectOption(selectedOption);
	}
}
